import React from 'react';
import classes from "./Circle2.module.css";

const Circle2 = ({ number, count, colorChange }) => {
    return (
        <div className={`${classes.circle} ${colorChange ? classes.circle_away : ''}`}>
            <p className={classes.number}>{number}</p>
            {count != null && count !== undefined && (
                <div className={`${classes.count_badge} ${colorChange ? classes.count_badge_away : ''}`}>
                    <p className={`${classes.count_text} ${colorChange ? classes.count_text_away : ''}`}>
                        {count}
                    </p>
                </div>
            )}
        </div>
    );
};

export default Circle2;